import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { ThemeProvider } from '@hpanel/web-common/contexts/ThemeContext'
// Plugin theme bridge — exposes --hp-* CSS variables on :root for
// plugin authors. See user-manual/docs/plugin-developers/stability.md.
import '../../../packages/web-common/src/styles/plugin-theme.css'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
)
